import { Inject, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { PAGE_BLOCK_KEYS_MAP, ProfileService, ProfileUserDTO } from 'library-explorer';

@Injectable({
  providedIn: 'root'
})
export class PageBlockService {
  private readonly GUEST_USER_NAME = 'COMMON.guest'

  constructor(
    @Inject(PAGE_BLOCK_KEYS_MAP) private readonly pageBlockKeysMap: any,
    private readonly translateService: TranslateService,
    private readonly profileService: ProfileService
  ) { }

  public parseBlockKeys(text: string): string {
    if (!text) {
      return '';
    }
  
    let result = text;
    let user: Partial<ProfileUserDTO> = this.profileService.getCurrentProfileValue();

    if (!user) {
      user = { name: this.translateService.instant(this.GUEST_USER_NAME) };
    }

    Object.keys(this.pageBlockKeysMap).forEach(key => {
      const regexp = new RegExp(`\\[${key}\\]`, 'ig');
      const value = user?.[this.pageBlockKeysMap[key]] || '';
      result = result.replace(regexp, value);
    });

    return result;
  }

}
